export default "__VITE_ASSET__BMnqN4VR__"